import type { QueryClient, QueryKey } from "@tanstack/react-query";

const TAGS_ENHANCED_ENTITIES = new Set<string>([
  "V4AdvReportByAd",
  "V4OrgReportByOrg",
  "V4TargetReportByTarget",
  "V4ProductReportByProduct",
  "V4ProductAds",
  "V4PricingPlanReportByPlan",
]);

const LEGACY_STRING_PREFIXES = new Set<string>(["tags", "products", "product_report", "ad_report"]);

const hasTagsEnhancedEntity = (key: QueryKey): boolean => {
  const first = key[0];
  if (!first || typeof first !== "object") return false;
  const entity = (first as { entity?: unknown }).entity;
  return typeof entity === "string" && TAGS_ENHANCED_ENTITIES.has(entity);
};

const hasLegacyStringPrefix = (key: QueryKey): boolean =>
  typeof key[0] === "string" && LEGACY_STRING_PREFIXES.has(key[0]);

export const invalidateTagAffectedQueries = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: [{ entity: "tags" }], refetchType: "all" });
  void queryClient.invalidateQueries({
    predicate: (query) => hasLegacyStringPrefix(query.queryKey) || hasTagsEnhancedEntity(query.queryKey),
  });
};
